import { render, staticRenderFns } from "./addAdvert.vue?vue&type=template&id=0b789526&scoped=true&"
import script from "./addAdvert.vue?vue&type=script&lang=js&"
export * from "./addAdvert.vue?vue&type=script&lang=js&"
import style0 from "./addAdvert.vue?vue&type=style&index=0&id=0b789526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b789526",
  null
  
)

export default component.exports